import DealDetailsHeader from './DealDetailsHeader';

export default DealDetailsHeader;
